export const HelsinkiTimes = {
    "0101": {
        "date": "0101",
        "fajr": "06:39",
        "sunrise": "09:19",
        "zuhur": "12:26",
        "asr": "13:19",
        "maghrib": "15:29",
        "isha": "18:01"
    },
    "0201": {
        "date": "0201",
        "fajr": "06:39",
        "sunrise": "09:19",
        "zuhur": "12:26",
        "asr": "13:20",
        "maghrib": "15:30",
        "isha": "18:02"
    },
    "0301": {
        "date": "0301",
        "fajr": "06:38",
        "sunrise": "09:18",
        "zuhur": "12:27",
        "asr": "13:22",
        "maghrib": "15:32",
        "isha": "18:03"
    },
    "0401": {
        "date": "0401",
        "fajr": "06:38",
        "sunrise": "09:17",
        "zuhur": "12:27",
        "asr": "13:23",
        "maghrib": "15:33",
        "isha": "18:04"
    },
    "0501": {
        "date": "0501",
        "fajr": "06:38",
        "sunrise": "09:17",
        "zuhur": "12:28",
        "asr": "13:24",
        "maghrib": "15:35",
        "isha": "18:06"
    },
    "0601": {
        "date": "0601",
        "fajr": "06:37",
        "sunrise": "09:16",
        "zuhur": "12:28",
        "asr": "13:25",
        "maghrib": "15:37",
        "isha": "18:07"
    },
    "0701": {
        "date": "0701",
        "fajr": "06:37",
        "sunrise": "09:15",
        "zuhur": "12:29",
        "asr": "13:27",
        "maghrib": "15:39",
        "isha": "18:08"
    },
    "0801": {
        "date": "0801",
        "fajr": "06:36",
        "sunrise": "09:14",
        "zuhur": "12:29",
        "asr": "13:28",
        "maghrib": "15:40",
        "isha": "18:10"
    },
    "0901": {
        "date": "0901",
        "fajr": "06:36",
        "sunrise": "09:13",
        "zuhur": "12:29",
        "asr": "13:29",
        "maghrib": "15:42",
        "isha": "18:11"
    },
    "1001": {
        "date": "1001",
        "fajr": "06:35",
        "sunrise": "09:12",
        "zuhur": "12:30",
        "asr": "13:31",
        "maghrib": "15:44",
        "isha": "18:13"
    },
    "1101": {
        "date": "1101",
        "fajr": "06:35",
        "sunrise": "09:10",
        "zuhur": "12:30",
        "asr": "13:32",
        "maghrib": "15:46",
        "isha": "18:14"
    },
    "1201": {
        "date": "1201",
        "fajr": "06:34",
        "sunrise": "09:09",
        "zuhur": "12:31",
        "asr": "13:34",
        "maghrib": "15:48",
        "isha": "18:16"
    },
    "1301": {
        "date": "1301",
        "fajr": "06:33",
        "sunrise": "09:08",
        "zuhur": "12:31",
        "asr": "13:35",
        "maghrib": "15:51",
        "isha": "18:17"
    },
    "1401": {
        "date": "1401",
        "fajr": "06:32",
        "sunrise": "09:06",
        "zuhur": "12:31",
        "asr": "13:37",
        "maghrib": "15:53",
        "isha": "18:19"
    },
    "1501": {
        "date": "1501",
        "fajr": "06:31",
        "sunrise": "09:05",
        "zuhur": "12:32",
        "asr": "13:38",
        "maghrib": "15:55",
        "isha": "18:20"
    },
    "1601": {
        "date": "1601",
        "fajr": "06:30",
        "sunrise": "09:03",
        "zuhur": "12:32",
        "asr": "13:40",
        "maghrib": "15:57",
        "isha": "18:22"
    },
    "1701": {
        "date": "1701",
        "fajr": "06:29",
        "sunrise": "09:02",
        "zuhur": "12:32",
        "asr": "13:42",
        "maghrib": "16:00",
        "isha": "18:24"
    },
    "1801": {
        "date": "1801",
        "fajr": "06:28",
        "sunrise": "09:00",
        "zuhur": "12:33",
        "asr": "13:43",
        "maghrib": "16:02",
        "isha": "18:26"
    },
    "1901": {
        "date": "1901",
        "fajr": "06:27",
        "sunrise": "08:58",
        "zuhur": "12:33",
        "asr": "13:45",
        "maghrib": "16:04",
        "isha": "18:27"
    },
    "2001": {
        "date": "2001",
        "fajr": "06:26",
        "sunrise": "08:57",
        "zuhur": "12:33",
        "asr": "13:47",
        "maghrib": "16:07",
        "isha": "18:29"
    },
    "2101": {
        "date": "2101",
        "fajr": "06:25",
        "sunrise": "08:55",
        "zuhur": "12:34",
        "asr": "13:49",
        "maghrib": "16:09",
        "isha": "18:31"
    },
    "2201": {
        "date": "2201",
        "fajr": "06:24",
        "sunrise": "08:53",
        "zuhur": "12:34",
        "asr": "13:50",
        "maghrib": "16:12",
        "isha": "18:33"
    },
    "2301": {
        "date": "2301",
        "fajr": "06:22",
        "sunrise": "08:51",
        "zuhur": "12:34",
        "asr": "13:52",
        "maghrib": "16:14",
        "isha": "18:35"
    },
    "2401": {
        "date": "2401",
        "fajr": "06:21",
        "sunrise": "08:49",
        "zuhur": "12:34",
        "asr": "13:54",
        "maghrib": "16:17",
        "isha": "18:37"
    },
    "2501": {
        "date": "2501",
        "fajr": "06:19",
        "sunrise": "08:47",
        "zuhur": "12:35",
        "asr": "13:56",
        "maghrib": "16:19",
        "isha": "18:39"
    },
    "2601": {
        "date": "2601",
        "fajr": "06:18",
        "sunrise": "08:45",
        "zuhur": "12:35",
        "asr": "13:58",
        "maghrib": "16:22",
        "isha": "18:41"
    },
    "2701": {
        "date": "2701",
        "fajr": "06:16",
        "sunrise": "08:43",
        "zuhur": "12:35",
        "asr": "14:00",
        "maghrib": "16:24",
        "isha": "18:43"
    },
    "2801": {
        "date": "2801",
        "fajr": "06:15",
        "sunrise": "08:40",
        "zuhur": "12:35",
        "asr": "14:01",
        "maghrib": "16:27",
        "isha": "18:45"
    },
    "2901": {
        "date": "2901",
        "fajr": "06:13",
        "sunrise": "08:38",
        "zuhur": "12:35",
        "asr": "14:03",
        "maghrib": "16:29",
        "isha": "18:47"
    },
    "3001": {
        "date": "3001",
        "fajr": "06:11",
        "sunrise": "08:36",
        "zuhur": "12:36",
        "asr": "14:05",
        "maghrib": "16:32",
        "isha": "18:49"
    },
    "3101": {
        "date": "3101",
        "fajr": "06:10",
        "sunrise": "08:34",
        "zuhur": "12:36",
        "asr": "14:07",
        "maghrib": "16:35",
        "isha": "18:51"
    },
    "0102": {
        "date": "0102",
        "fajr": "06:08",
        "sunrise": "08:31",
        "zuhur": "12:36",
        "asr": "14:09",
        "maghrib": "16:37",
        "isha": "18:53"
    },
    "0202": {
        "date": "0202",
        "fajr": "06:06",
        "sunrise": "08:29",
        "zuhur": "12:36",
        "asr": "14:11",
        "maghrib": "16:40",
        "isha": "18:55"
    },
    "0302": {
        "date": "0302",
        "fajr": "06:04",
        "sunrise": "08:27",
        "zuhur": "12:36",
        "asr": "14:13",
        "maghrib": "16:42",
        "isha": "18:57"
    },
    "0402": {
        "date": "0402",
        "fajr": "06:02",
        "sunrise": "08:24",
        "zuhur": "12:36",
        "asr": "14:15",
        "maghrib": "16:45",
        "isha": "18:59"
    },
    "0502": {
        "date": "0502",
        "fajr": "06:00",
        "sunrise": "08:22",
        "zuhur": "12:36",
        "asr": "14:17",
        "maghrib": "16:48",
        "isha": "19:01"
    },
    "0602": {
        "date": "0602",
        "fajr": "05:58",
        "sunrise": "08:19",
        "zuhur": "12:36",
        "asr": "14:19",
        "maghrib": "16:50",
        "isha": "19:04"
    },
    "0702": {
        "date": "0702",
        "fajr": "05:56",
        "sunrise": "08:17",
        "zuhur": "12:36",
        "asr": "14:21",
        "maghrib": "16:53",
        "isha": "19:06"
    },
    "0802": {
        "date": "0802",
        "fajr": "05:54",
        "sunrise": "08:14",
        "zuhur": "12:36",
        "asr": "14:23",
        "maghrib": "16:56",
        "isha": "19:08"
    },
    "0902": {
        "date": "0902",
        "fajr": "05:52",
        "sunrise": "08:12",
        "zuhur": "12:36",
        "asr": "14:25",
        "maghrib": "16:58",
        "isha": "19:10"
    },
    "1002": {
        "date": "1002",
        "fajr": "05:50",
        "sunrise": "08:09",
        "zuhur": "12:36",
        "asr": "14:27",
        "maghrib": "17:01",
        "isha": "19:13"
    },
    "1102": {
        "date": "1102",
        "fajr": "05:47",
        "sunrise": "08:06",
        "zuhur": "12:36",
        "asr": "14:28",
        "maghrib": "17:04",
        "isha": "19:15"
    },
    "1202": {
        "date": "1202",
        "fajr": "05:45",
        "sunrise": "08:04",
        "zuhur": "12:36",
        "asr": "14:30",
        "maghrib": "17:06",
        "isha": "19:17"
    },
    "1302": {
        "date": "1302",
        "fajr": "05:43",
        "sunrise": "08:01",
        "zuhur": "12:36",
        "asr": "14:32",
        "maghrib": "17:09",
        "isha": "19:19"
    },
    "1402": {
        "date": "1402",
        "fajr": "05:40",
        "sunrise": "07:58",
        "zuhur": "12:36",
        "asr": "14:34",
        "maghrib": "17:11",
        "isha": "19:22"
    },
    "1502": {
        "date": "1502",
        "fajr": "05:38",
        "sunrise": "07:56",
        "zuhur": "12:36",
        "asr": "14:36",
        "maghrib": "17:14",
        "isha": "19:24"
    },
    "1602": {
        "date": "1602",
        "fajr": "05:35",
        "sunrise": "07:53",
        "zuhur": "12:36",
        "asr": "14:38",
        "maghrib": "17:17",
        "isha": "19:27"
    },
    "1702": {
        "date": "1702",
        "fajr": "05:33",
        "sunrise": "07:50",
        "zuhur": "12:36",
        "asr": "14:40",
        "maghrib": "17:19",
        "isha": "19:29"
    },
    "1802": {
        "date": "1802",
        "fajr": "05:30",
        "sunrise": "07:48",
        "zuhur": "12:36",
        "asr": "14:42",
        "maghrib": "17:22",
        "isha": "19:31"
    },
    "1902": {
        "date": "1902",
        "fajr": "05:28",
        "sunrise": "07:45",
        "zuhur": "12:36",
        "asr": "14:44",
        "maghrib": "17:25",
        "isha": "19:34"
    },
    "2002": {
        "date": "2002",
        "fajr": "05:25",
        "sunrise": "07:42",
        "zuhur": "12:36",
        "asr": "14:46",
        "maghrib": "17:27",
        "isha": "19:36"
    },
    "2102": {
        "date": "2102",
        "fajr": "05:23",
        "sunrise": "07:39",
        "zuhur": "12:36",
        "asr": "14:48",
        "maghrib": "17:30",
        "isha": "19:39"
    },
    "2202": {
        "date": "2202",
        "fajr": "05:20",
        "sunrise": "07:36",
        "zuhur": "12:36",
        "asr": "14:50",
        "maghrib": "17:32",
        "isha": "19:41"
    },
    "2302": {
        "date": "2302",
        "fajr": "05:17",
        "sunrise": "07:33",
        "zuhur": "12:36",
        "asr": "14:51",
        "maghrib": "17:35",
        "isha": "19:43"
    },
    "2402": {
        "date": "2402",
        "fajr": "05:14",
        "sunrise": "07:31",
        "zuhur": "12:35",
        "asr": "14:53",
        "maghrib": "17:37",
        "isha": "19:46"
    },
    "2502": {
        "date": "2502",
        "fajr": "05:12",
        "sunrise": "07:28",
        "zuhur": "12:35",
        "asr": "14:55",
        "maghrib": "17:40",
        "isha": "19:48"
    },
    "2602": {
        "date": "2602",
        "fajr": "05:09",
        "sunrise": "07:25",
        "zuhur": "12:35",
        "asr": "14:57",
        "maghrib": "17:43",
        "isha": "19:51"
    },
    "2702": {
        "date": "2702",
        "fajr": "05:06",
        "sunrise": "07:22",
        "zuhur": "12:35",
        "asr": "14:59",
        "maghrib": "17:45",
        "isha": "19:54"
    },
    "2802": {
        "date": "2802",
        "fajr": "05:03",
        "sunrise": "07:19",
        "zuhur": "12:35",
        "asr": "15:01",
        "maghrib": "17:48",
        "isha": "19:56"
    },
    "0103": {
        "date": "0103",
        "fajr": "05:00",
        "sunrise": "07:16",
        "zuhur": "12:35",
        "asr": "15:02",
        "maghrib": "17:50",
        "isha": "19:59"
    },
    "0203": {
        "date": "0203",
        "fajr": "04:57",
        "sunrise": "07:13",
        "zuhur": "12:34",
        "asr": "15:04",
        "maghrib": "17:53",
        "isha": "20:01"
    },
    "0303": {
        "date": "0303",
        "fajr": "04:54",
        "sunrise": "07:10",
        "zuhur": "12:34",
        "asr": "15:06",
        "maghrib": "17:55",
        "isha": "20:04"
    },
    "0403": {
        "date": "0403",
        "fajr": "04:51",
        "sunrise": "07:07",
        "zuhur": "12:34",
        "asr": "15:08",
        "maghrib": "17:58",
        "isha": "20:06"
    },
    "0503": {
        "date": "0503",
        "fajr": "04:48",
        "sunrise": "07:04",
        "zuhur": "12:34",
        "asr": "15:09",
        "maghrib": "18:00",
        "isha": "20:09"
    },
    "0603": {
        "date": "0603",
        "fajr": "04:45",
        "sunrise": "07:01",
        "zuhur": "12:34",
        "asr": "15:11",
        "maghrib": "18:03",
        "isha": "20:12"
    },
    "0703": {
        "date": "0703",
        "fajr": "04:41",
        "sunrise": "06:58",
        "zuhur": "12:33",
        "asr": "15:13",
        "maghrib": "18:05",
        "isha": "20:15"
    },
    "0803": {
        "date": "0803",
        "fajr": "04:38",
        "sunrise": "06:55",
        "zuhur": "12:33",
        "asr": "15:15",
        "maghrib": "18:08",
        "isha": "20:17"
    },
    "0903": {
        "date": "0903",
        "fajr": "04:35",
        "sunrise": "06:52",
        "zuhur": "12:33",
        "asr": "15:16",
        "maghrib": "18:10",
        "isha": "20:20"
    },
    "1003": {
        "date": "1003",
        "fajr": "04:32",
        "sunrise": "06:49",
        "zuhur": "12:33",
        "asr": "15:18",
        "maghrib": "18:13",
        "isha": "20:23"
    },
    "1103": {
        "date": "1103",
        "fajr": "04:28",
        "sunrise": "06:46",
        "zuhur": "12:32",
        "asr": "15:20",
        "maghrib": "18:15",
        "isha": "20:26"
    },
    "1203": {
        "date": "1203",
        "fajr": "04:25",
        "sunrise": "06:43",
        "zuhur": "12:32",
        "asr": "15:21",
        "maghrib": "18:18",
        "isha": "20:28"
    },
    "1303": {
        "date": "1303",
        "fajr": "04:21",
        "sunrise": "06:40",
        "zuhur": "12:32",
        "asr": "15:23",
        "maghrib": "18:20",
        "isha": "20:31"
    },
    "1403": {
        "date": "1403",
        "fajr": "04:18",
        "sunrise": "06:37",
        "zuhur": "12:31",
        "asr": "15:25",
        "maghrib": "18:23",
        "isha": "20:34"
    },
    "1503": {
        "date": "1503",
        "fajr": "04:14",
        "sunrise": "06:34",
        "zuhur": "12:31",
        "asr": "15:26",
        "maghrib": "18:25",
        "isha": "20:37"
    },
    "1603": {
        "date": "1603",
        "fajr": "04:11",
        "sunrise": "06:31",
        "zuhur": "12:31",
        "asr": "15:28",
        "maghrib": "18:28",
        "isha": "20:40"
    },
    "1703": {
        "date": "1703",
        "fajr": "04:07",
        "sunrise": "06:28",
        "zuhur": "12:31",
        "asr": "15:30",
        "maghrib": "18:30",
        "isha": "20:43"
    },
    "1803": {
        "date": "1803",
        "fajr": "04:04",
        "sunrise": "06:25",
        "zuhur": "12:30",
        "asr": "15:31",
        "maghrib": "18:33",
        "isha": "20:46"
    },
    "1903": {
        "date": "1903",
        "fajr": "04:00",
        "sunrise": "06:22",
        "zuhur": "12:30",
        "asr": "15:33",
        "maghrib": "18:35",
        "isha": "20:49"
    },
    "2003": {
        "date": "2003",
        "fajr": "03:56",
        "sunrise": "06:19",
        "zuhur": "12:30",
        "asr": "15:34",
        "maghrib": "18:38",
        "isha": "20:52"
    },
    "2103": {
        "date": "2103",
        "fajr": "03:52",
        "sunrise": "06:16",
        "zuhur": "12:29",
        "asr": "15:36",
        "maghrib": "18:40",
        "isha": "20:55"
    },
    "2203": {
        "date": "2203",
        "fajr": "03:48",
        "sunrise": "06:13",
        "zuhur": "12:29",
        "asr": "15:37",
        "maghrib": "18:43",
        "isha": "20:59"
    },
    "2303": {
        "date": "2303",
        "fajr": "03:45",
        "sunrise": "06:10",
        "zuhur": "12:29",
        "asr": "15:39",
        "maghrib": "18:45",
        "isha": "21:02"
    },
    "2403": {
        "date": "2403",
        "fajr": "03:41",
        "sunrise": "06:07",
        "zuhur": "12:29",
        "asr": "15:40",
        "maghrib": "18:48",
        "isha": "21:05"
    },
    "2503": {
        "date": "2503",
        "fajr": "03:37",
        "sunrise": "06:04",
        "zuhur": "12:28",
        "asr": "15:42",
        "maghrib": "18:50",
        "isha": "21:08"
    },
    "2603": {
        "date": "2603",
        "fajr": "03:32",
        "sunrise": "06:01",
        "zuhur": "12:28",
        "asr": "15:43",
        "maghrib": "18:53",
        "isha": "21:12"
    },
    "2703": {
        "date": "2703",
        "fajr": "03:28",
        "sunrise": "05:58",
        "zuhur": "12:28",
        "asr": "15:45",
        "maghrib": "18:55",
        "isha": "21:15"
    },
    "2803": {
        "date": "2803",
        "fajr": "03:24",
        "sunrise": "05:55",
        "zuhur": "12:27",
        "asr": "15:46",
        "maghrib": "18:57",
        "isha": "21:19"
    },
    "2903": {
        "date": "2903",
        "fajr": "04:20",
        "sunrise": "06:52",
        "zuhur": "13:27",
        "asr": "16:48",
        "maghrib": "20:00",
        "isha": "22:22"
    },
    "3003": {
        "date": "3003",
        "fajr": "04:15",
        "sunrise": "06:49",
        "zuhur": "13:27",
        "asr": "16:49",
        "maghrib": "20:02",
        "isha": "22:26"
    },
    "3103": {
        "date": "3103",
        "fajr": "04:11",
        "sunrise": "06:46",
        "zuhur": "13:26",
        "asr": "16:51",
        "maghrib": "20:05",
        "isha": "22:30"
    },
    "0104": {
        "date": "0104",
        "fajr": "04:07",
        "sunrise": "06:43",
        "zuhur": "13:26",
        "asr": "16:52",
        "maghrib": "20:07",
        "isha": "22:33"
    },
    "0204": {
        "date": "0204",
        "fajr": "04:02",
        "sunrise": "06:39",
        "zuhur": "13:26",
        "asr": "16:53",
        "maghrib": "20:10",
        "isha": "22:37"
    },
    "0304": {
        "date": "0304",
        "fajr": "03:57",
        "sunrise": "06:36",
        "zuhur": "13:26",
        "asr": "16:55",
        "maghrib": "20:12",
        "isha": "22:41"
    },
    "0404": {
        "date": "0404",
        "fajr": "03:52",
        "sunrise": "06:33",
        "zuhur": "13:25",
        "asr": "16:56",
        "maghrib": "20:15",
        "isha": "22:45"
    },
    "0504": {
        "date": "0504",
        "fajr": "03:47",
        "sunrise": "06:30",
        "zuhur": "13:25",
        "asr": "16:57",
        "maghrib": "20:17",
        "isha": "22:49"
    },
    "0604": {
        "date": "0604",
        "fajr": "03:42",
        "sunrise": "06:27",
        "zuhur": "13:25",
        "asr": "16:59",
        "maghrib": "20:20",
        "isha": "22:54"
    },
    "0704": {
        "date": "0704",
        "fajr": "03:37",
        "sunrise": "06:24",
        "zuhur": "13:24",
        "asr": "17:00",
        "maghrib": "20:22",
        "isha": "22:58"
    },
    "0804": {
        "date": "0804",
        "fajr": "03:32",
        "sunrise": "06:21",
        "zuhur": "13:24",
        "asr": "17:01",
        "maghrib": "20:25",
        "isha": "23:03"
    },
    "0904": {
        "date": "0904",
        "fajr": "03:26",
        "sunrise": "06:18",
        "zuhur": "13:24",
        "asr": "17:03",
        "maghrib": "20:27",
        "isha": "23:07"
    },
    "1004": {
        "date": "1004",
        "fajr": "03:21",
        "sunrise": "06:15",
        "zuhur": "13:24",
        "asr": "17:04",
        "maghrib": "20:30",
        "isha": "23:12"
    },
    "1104": {
        "date": "1104",
        "fajr": "03:15",
        "sunrise": "06:12",
        "zuhur": "13:23",
        "asr": "17:05",
        "maghrib": "20:32",
        "isha": "23:17"
    },
    "1204": {
        "date": "1204",
        "fajr": "03:09",
        "sunrise": "06:09",
        "zuhur": "13:23",
        "asr": "17:07",
        "maghrib": "20:35",
        "isha": "23:22"
    },
    "1304": {
        "date": "1304",
        "fajr": "03:02",
        "sunrise": "06:06",
        "zuhur": "13:23",
        "asr": "17:08",
        "maghrib": "20:37",
        "isha": "23:28"
    },
    "1404": {
        "date": "1404",
        "fajr": "02:55",
        "sunrise": "06:03",
        "zuhur": "13:23",
        "asr": "17:09",
        "maghrib": "20:40",
        "isha": "23:33"
    },
    "1504": {
        "date": "1504",
        "fajr": "02:48",
        "sunrise": "06:00",
        "zuhur": "13:22",
        "asr": "17:10",
        "maghrib": "20:42",
        "isha": "23:39"
    },
    "1604": {
        "date": "1604",
        "fajr": "02:40",
        "sunrise": "05:57",
        "zuhur": "13:22",
        "asr": "17:12",
        "maghrib": "20:45",
        "isha": "23:46"
    },
    "1704": {
        "date": "1704",
        "fajr": "02:32",
        "sunrise": "05:54",
        "zuhur": "13:22",
        "asr": "17:13",
        "maghrib": "20:47",
        "isha": "23:52"
    },
    "1804": {
        "date": "1804",
        "fajr": "02:22",
        "sunrise": "05:51",
        "zuhur": "13:22",
        "asr": "17:14",
        "maghrib": "20:50",
        "isha": "24:00"
    },
    "1904": {
        "date": "1904",
        "fajr": "02:20",
        "sunrise": "05:48",
        "zuhur": "13:21",
        "asr": "17:15",
        "maghrib": "20:52",
        "isha": "00:08"
    },
    "2004": {
        "date": "2004",
        "fajr": "02:17",
        "sunrise": "05:45",
        "zuhur": "13:21",
        "asr": "17:16",
        "maghrib": "20:55",
        "isha": "00:17"
    },
    "2104": {
        "date": "2104",
        "fajr": "02:15",
        "sunrise": "05:42",
        "zuhur": "13:21",
        "asr": "17:18",
        "maghrib": "20:57",
        "isha": "00:27"
    },
    "2204": {
        "date": "2204",
        "fajr": "02:14",
        "sunrise": "05:40",
        "zuhur": "13:21",
        "asr": "17:19",
        "maghrib": "21:00",
        "isha": "22:28"
    },
    "2304": {
        "date": "2304",
        "fajr": "02:13",
        "sunrise": "05:37",
        "zuhur": "13:21",
        "asr": "17:20",
        "maghrib": "21:02",
        "isha": "22:30"
    },
    "2404": {
        "date": "2404",
        "fajr": "02:13",
        "sunrise": "05:34",
        "zuhur": "13:20",
        "asr": "17:21",
        "maghrib": "21:05",
        "isha": "22:33"
    },
    "2504": {
        "date": "2504",
        "fajr": "02:13",
        "sunrise": "05:31",
        "zuhur": "13:20",
        "asr": "17:22",
        "maghrib": "21:07",
        "isha": "22:35"
    },
    "2604": {
        "date": "2604",
        "fajr": "02:12",
        "sunrise": "05:28",
        "zuhur": "13:20",
        "asr": "17:23",
        "maghrib": "21:10",
        "isha": "22:38"
    },
    "2704": {
        "date": "2704",
        "fajr": "02:12",
        "sunrise": "05:25",
        "zuhur": "13:20",
        "asr": "17:24",
        "maghrib": "21:12",
        "isha": "22:40"
    },
    "2804": {
        "date": "2804",
        "fajr": "02:12",
        "sunrise": "05:22",
        "zuhur": "13:20",
        "asr": "17:25",
        "maghrib": "21:15",
        "isha": "22:43"
    },
    "2904": {
        "date": "2904",
        "fajr": "02:11",
        "sunrise": "05:20",
        "zuhur": "13:20",
        "asr": "17:27",
        "maghrib": "21:18",
        "isha": "22:45"
    },
    "3004": {
        "date": "3004",
        "fajr": "02:11",
        "sunrise": "05:17",
        "zuhur": "13:20",
        "asr": "17:28",
        "maghrib": "21:20",
        "isha": "22:48"
    },
    "0105": {
        "date": "0105",
        "fajr": "02:11",
        "sunrise": "05:14",
        "zuhur": "13:19",
        "asr": "17:29",
        "maghrib": "21:23",
        "isha": "22:50"
    },
    "0205": {
        "date": "0205",
        "fajr": "02:11",
        "sunrise": "05:11",
        "zuhur": "13:19",
        "asr": "17:30",
        "maghrib": "21:25",
        "isha": "22:53"
    },
    "0305": {
        "date": "0305",
        "fajr": "02:10",
        "sunrise": "05:08",
        "zuhur": "13:19",
        "asr": "17:31",
        "maghrib": "21:28",
        "isha": "22:55"
    },
    "0405": {
        "date": "0405",
        "fajr": "02:10",
        "sunrise": "05:06",
        "zuhur": "13:19",
        "asr": "17:32",
        "maghrib": "21:30",
        "isha": "22:58"
    },
    "0505": {
        "date": "0505",
        "fajr": "02:10",
        "sunrise": "05:03",
        "zuhur": "13:19",
        "asr": "17:33",
        "maghrib": "21:33",
        "isha": "23:00"
    },
    "0605": {
        "date": "0605",
        "fajr": "02:10",
        "sunrise": "05:00",
        "zuhur": "13:19",
        "asr": "17:34",
        "maghrib": "21:35",
        "isha": "23:03"
    },
    "0705": {
        "date": "0705",
        "fajr": "02:09",
        "sunrise": "04:58",
        "zuhur": "13:19",
        "asr": "17:35",
        "maghrib": "21:38",
        "isha": "23:05"
    },
    "0805": {
        "date": "0805",
        "fajr": "02:09",
        "sunrise": "04:55",
        "zuhur": "13:19",
        "asr": "17:36",
        "maghrib": "21:40",
        "isha": "23:07"
    },
    "0905": {
        "date": "0905",
        "fajr": "02:09",
        "sunrise": "04:52",
        "zuhur": "13:19",
        "asr": "17:37",
        "maghrib": "21:43",
        "isha": "23:10"
    },
    "1005": {
        "date": "1005",
        "fajr": "02:09",
        "sunrise": "04:50",
        "zuhur": "13:19",
        "asr": "17:38",
        "maghrib": "21:45",
        "isha": "23:12"
    },
    "1105": {
        "date": "1105",
        "fajr": "02:08",
        "sunrise": "04:47",
        "zuhur": "13:19",
        "asr": "17:39",
        "maghrib": "21:48",
        "isha": "23:15"
    },
    "1205": {
        "date": "1205",
        "fajr": "02:08",
        "sunrise": "04:45",
        "zuhur": "13:19",
        "asr": "17:40",
        "maghrib": "21:50",
        "isha": "23:17"
    },
    "1305": {
        "date": "1305",
        "fajr": "02:08",
        "sunrise": "04:42",
        "zuhur": "13:19",
        "asr": "17:41",
        "maghrib": "21:53",
        "isha": "23:19"
    },
    "1405": {
        "date": "1405",
        "fajr": "02:08",
        "sunrise": "04:40",
        "zuhur": "13:19",
        "asr": "17:42",
        "maghrib": "21:55",
        "isha": "23:22"
    },
    "1505": {
        "date": "1505",
        "fajr": "02:08",
        "sunrise": "04:37",
        "zuhur": "13:19",
        "asr": "17:42",
        "maghrib": "21:58",
        "isha": "23:24"
    },
    "1605": {
        "date": "1605",
        "fajr": "02:07",
        "sunrise": "04:35",
        "zuhur": "13:19",
        "asr": "17:43",
        "maghrib": "22:00",
        "isha": "23:26"
    },
    "1705": {
        "date": "1705",
        "fajr": "02:07",
        "sunrise": "04:33",
        "zuhur": "13:19",
        "asr": "17:44",
        "maghrib": "22:02",
        "isha": "23:29"
    },
    "1805": {
        "date": "1805",
        "fajr": "02:07",
        "sunrise": "04:30",
        "zuhur": "13:19",
        "asr": "17:45",
        "maghrib": "22:05",
        "isha": "23:31"
    },
    "1905": {
        "date": "1905",
        "fajr": "02:07",
        "sunrise": "04:28",
        "zuhur": "13:19",
        "asr": "17:46",
        "maghrib": "22:07",
        "isha": "23:33"
    },
    "2005": {
        "date": "2005",
        "fajr": "02:06",
        "sunrise": "04:26",
        "zuhur": "13:19",
        "asr": "17:47",
        "maghrib": "22:09",
        "isha": "23:35"
    },
    "2105": {
        "date": "2105",
        "fajr": "02:06",
        "sunrise": "04:24",
        "zuhur": "13:19",
        "asr": "17:48",
        "maghrib": "22:12",
        "isha": "23:37"
    },
    "2205": {
        "date": "2205",
        "fajr": "02:05",
        "sunrise": "04:22",
        "zuhur": "13:19",
        "asr": "17:48",
        "maghrib": "22:14",
        "isha": "23:39"
    },
    "2305": {
        "date": "2305",
        "fajr": "02:05",
        "sunrise": "04:19",
        "zuhur": "13:19",
        "asr": "17:49",
        "maghrib": "22:16",
        "isha": "23:42"
    },
    "2405": {
        "date": "2405",
        "fajr": "02:04",
        "sunrise": "04:17",
        "zuhur": "13:19",
        "asr": "17:50",
        "maghrib": "22:18",
        "isha": "23:44"
    },
    "2505": {
        "date": "2505",
        "fajr": "02:04",
        "sunrise": "04:15",
        "zuhur": "13:19",
        "asr": "17:51",
        "maghrib": "22:21",
        "isha": "23:46"
    },
    "2605": {
        "date": "2605",
        "fajr": "02:03",
        "sunrise": "04:14",
        "zuhur": "13:19",
        "asr": "17:52",
        "maghrib": "22:23",
        "isha": "23:47"
    },
    "2705": {
        "date": "2705",
        "fajr": "02:03",
        "sunrise": "04:12",
        "zuhur": "13:19",
        "asr": "17:52",
        "maghrib": "22:25",
        "isha": "23:49"
    },
    "2805": {
        "date": "2805",
        "fajr": "02:02",
        "sunrise": "04:10",
        "zuhur": "13:20",
        "asr": "17:53",
        "maghrib": "22:27",
        "isha": "23:51"
    },
    "2905": {
        "date": "2905",
        "fajr": "02:02",
        "sunrise": "04:08",
        "zuhur": "13:20",
        "asr": "17:54",
        "maghrib": "22:29",
        "isha": "23:53"
    },
    "3005": {
        "date": "3005",
        "fajr": "02:01",
        "sunrise": "04:06",
        "zuhur": "13:20",
        "asr": "17:54",
        "maghrib": "22:31",
        "isha": "23:55"
    },
    "3105": {
        "date": "3105",
        "fajr": "02:01",
        "sunrise": "04:05",
        "zuhur": "13:20",
        "asr": "17:55",
        "maghrib": "22:33",
        "isha": "23:56"
    },
    "0106": {
        "date": "0106",
        "fajr": "02:00",
        "sunrise": "04:03",
        "zuhur": "13:20",
        "asr": "17:56",
        "maghrib": "22:35",
        "isha": "23:58"
    },
    "0206": {
        "date": "0206",
        "fajr": "02:00",
        "sunrise": "04:02",
        "zuhur": "13:20",
        "asr": "17:56",
        "maghrib": "22:36",
        "isha": "24:00"
    },
    "0306": {
        "date": "0306",
        "fajr": "01:59",
        "sunrise": "04:00",
        "zuhur": "13:20",
        "asr": "17:57",
        "maghrib": "22:38",
        "isha": "00:01"
    },
    "0406": {
        "date": "0406",
        "fajr": "01:59",
        "sunrise": "03:59",
        "zuhur": "13:21",
        "asr": "17:58",
        "maghrib": "22:40",
        "isha": "00:03"
    },
    "0506": {
        "date": "0506",
        "fajr": "01:58",
        "sunrise": "03:57",
        "zuhur": "13:21",
        "asr": "17:58",
        "maghrib": "22:41",
        "isha": "00:04"
    },
    "0606": {
        "date": "0606",
        "fajr": "01:58",
        "sunrise": "03:56",
        "zuhur": "13:21",
        "asr": "17:59",
        "maghrib": "22:43",
        "isha": "00:05"
    },
    "0706": {
        "date": "0706",
        "fajr": "01:57",
        "sunrise": "03:55",
        "zuhur": "13:21",
        "asr": "17:59",
        "maghrib": "22:44",
        "isha": "00:07"
    },
    "0806": {
        "date": "0806",
        "fajr": "01:57",
        "sunrise": "03:54",
        "zuhur": "13:21",
        "asr": "18:00",
        "maghrib": "22:46",
        "isha": "00:08"
    },
    "0906": {
        "date": "0906",
        "fajr": "01:56",
        "sunrise": "03:53",
        "zuhur": "13:22",
        "asr": "18:00",
        "maghrib": "22:47",
        "isha": "00:09"
    },
    "1006": {
        "date": "1006",
        "fajr": "01:56",
        "sunrise": "03:52",
        "zuhur": "13:22",
        "asr": "18:01",
        "maghrib": "22:48",
        "isha": "00:10"
    },
    "1106": {
        "date": "1106",
        "fajr": "01:55",
        "sunrise": "03:51",
        "zuhur": "13:22",
        "asr": "18:01",
        "maghrib": "22:49",
        "isha": "00:11"
    },
    "1206": {
        "date": "1206",
        "fajr": "01:55",
        "sunrise": "03:51",
        "zuhur": "13:22",
        "asr": "18:02",
        "maghrib": "22:50",
        "isha": "00:12"
    },
    "1306": {
        "date": "1306",
        "fajr": "01:54",
        "sunrise": "03:50",
        "zuhur": "13:22",
        "asr": "18:02",
        "maghrib": "22:51",
        "isha": "00:13"
    },
    "1406": {
        "date": "1406",
        "fajr": "01:54",
        "sunrise": "03:50",
        "zuhur": "13:23",
        "asr": "18:03",
        "maghrib": "22:52",
        "isha": "00:13"
    },
    "1506": {
        "date": "1506",
        "fajr": "01:53",
        "sunrise": "03:49",
        "zuhur": "13:23",
        "asr": "18:03",
        "maghrib": "22:53",
        "isha": "00:14"
    },
    "1606": {
        "date": "1606",
        "fajr": "01:53",
        "sunrise": "03:49",
        "zuhur": "13:23",
        "asr": "18:03",
        "maghrib": "22:54",
        "isha": "00:15"
    },
    "1706": {
        "date": "1706",
        "fajr": "01:52",
        "sunrise": "03:49",
        "zuhur": "13:23",
        "asr": "18:04",
        "maghrib": "22:54",
        "isha": "00:15"
    },
    "1806": {
        "date": "1806",
        "fajr": "01:51",
        "sunrise": "03:48",
        "zuhur": "13:23",
        "asr": "18:04",
        "maghrib": "22:55",
        "isha": "00:16"
    },
    "1906": {
        "date": "1906",
        "fajr": "01:51",
        "sunrise": "03:48",
        "zuhur": "13:24",
        "asr": "18:04",
        "maghrib": "22:55",
        "isha": "00:16"
    },
    "2006": {
        "date": "2006",
        "fajr": "01:51",
        "sunrise": "03:48",
        "zuhur": "13:24",
        "asr": "18:04",
        "maghrib": "22:55",
        "isha": "00:16"
    },
    "2106": {
        "date": "2106",
        "fajr": "01:51",
        "sunrise": "03:49",
        "zuhur": "13:24",
        "asr": "18:05",
        "maghrib": "22:56",
        "isha": "00:17"
    },
    "2206": {
        "date": "2206",
        "fajr": "01:51",
        "sunrise": "03:49",
        "zuhur": "13:24",
        "asr": "18:05",
        "maghrib": "22:56",
        "isha": "00:17"
    },
    "2306": {
        "date": "2306",
        "fajr": "01:52",
        "sunrise": "03:49",
        "zuhur": "13:25",
        "asr": "18:05",
        "maghrib": "22:56",
        "isha": "00:17"
    },
    "2406": {
        "date": "2406",
        "fajr": "01:52",
        "sunrise": "03:50",
        "zuhur": "13:25",
        "asr": "18:05",
        "maghrib": "22:56",
        "isha": "00:17"
    },
    "2506": {
        "date": "2506",
        "fajr": "01:53",
        "sunrise": "03:50",
        "zuhur": "13:25",
        "asr": "18:05",
        "maghrib": "22:56",
        "isha": "00:16"
    },
    "2606": {
        "date": "2606",
        "fajr": "01:53",
        "sunrise": "03:51",
        "zuhur": "13:25",
        "asr": "18:05",
        "maghrib": "22:55",
        "isha": "00:16"
    },
    "2706": {
        "date": "2706",
        "fajr": "01:53",
        "sunrise": "03:51",
        "zuhur": "13:25",
        "asr": "18:05",
        "maghrib": "22:55",
        "isha": "00:16"
    },
    "2806": {
        "date": "2806",
        "fajr": "01:54",
        "sunrise": "03:52",
        "zuhur": "13:26",
        "asr": "18:05",
        "maghrib": "22:55",
        "isha": "00:16"
    },
    "2906": {
        "date": "2906",
        "fajr": "01:54",
        "sunrise": "03:53",
        "zuhur": "13:26",
        "asr": "18:05",
        "maghrib": "22:54",
        "isha": "00:15"
    },
    "3006": {
        "date": "3006",
        "fajr": "01:54",
        "sunrise": "03:54",
        "zuhur": "13:26",
        "asr": "18:05",
        "maghrib": "22:53",
        "isha": "00:15"
    },
    "0107": {
        "date": "0107",
        "fajr": "01:55",
        "sunrise": "03:55",
        "zuhur": "13:26",
        "asr": "18:05",
        "maghrib": "22:53",
        "isha": "00:14"
    },
    "0207": {
        "date": "0207",
        "fajr": "01:55",
        "sunrise": "03:56",
        "zuhur": "13:26",
        "asr": "18:05",
        "maghrib": "22:52",
        "isha": "00:13"
    },
    "0307": {
        "date": "0307",
        "fajr": "01:56",
        "sunrise": "03:57",
        "zuhur": "13:27",
        "asr": "18:05",
        "maghrib": "22:51",
        "isha": "00:13"
    },
    "0407": {
        "date": "0407",
        "fajr": "01:56",
        "sunrise": "03:59",
        "zuhur": "13:27",
        "asr": "18:05",
        "maghrib": "22:50",
        "isha": "00:12"
    },
    "0507": {
        "date": "0507",
        "fajr": "01:57",
        "sunrise": "04:00",
        "zuhur": "13:27",
        "asr": "18:05",
        "maghrib": "22:49",
        "isha": "00:11"
    },
    "0607": {
        "date": "0607",
        "fajr": "01:57",
        "sunrise": "04:02",
        "zuhur": "13:27",
        "asr": "18:05",
        "maghrib": "22:48",
        "isha": "00:10"
    },
    "0707": {
        "date": "0707",
        "fajr": "01:58",
        "sunrise": "04:03",
        "zuhur": "13:27",
        "asr": "18:04",
        "maghrib": "22:46",
        "isha": "00:09"
    },
    "0807": {
        "date": "0807",
        "fajr": "01:58",
        "sunrise": "04:05",
        "zuhur": "13:27",
        "asr": "18:04",
        "maghrib": "22:45",
        "isha": "00:07"
    },
    "0907": {
        "date": "0907",
        "fajr": "01:59",
        "sunrise": "04:06",
        "zuhur": "13:28",
        "asr": "18:04",
        "maghrib": "22:44",
        "isha": "00:06"
    },
    "1007": {
        "date": "1007",
        "fajr": "01:59",
        "sunrise": "04:08",
        "zuhur": "13:28",
        "asr": "18:03",
        "maghrib": "22:42",
        "isha": "00:05"
    },
    "1107": {
        "date": "1107",
        "fajr": "01:59",
        "sunrise": "04:10",
        "zuhur": "13:28",
        "asr": "18:03",
        "maghrib": "22:41",
        "isha": "00:04"
    },
    "1207": {
        "date": "1207",
        "fajr": "01:59",
        "sunrise": "04:12",
        "zuhur": "13:28",
        "asr": "18:03",
        "maghrib": "22:39",
        "isha": "00:02"
    },
    "1307": {
        "date": "1307",
        "fajr": "02:00",
        "sunrise": "04:13",
        "zuhur": "13:28",
        "asr": "18:02",
        "maghrib": "22:37",
        "isha": "00:01"
    },
    "1407": {
        "date": "1407",
        "fajr": "02:00",
        "sunrise": "04:15",
        "zuhur": "13:28",
        "asr": "18:02",
        "maghrib": "22:36",
        "isha": "23:59"
    },
    "1507": {
        "date": "1507",
        "fajr": "02:00",
        "sunrise": "04:17",
        "zuhur": "13:28",
        "asr": "18:01",
        "maghrib": "22:34",
        "isha": "23:58"
    },
    "1607": {
        "date": "1607",
        "fajr": "02:00",
        "sunrise": "04:19",
        "zuhur": "13:28",
        "asr": "18:01",
        "maghrib": "22:32",
        "isha": "23:56"
    },
    "1707": {
        "date": "1707",
        "fajr": "02:00",
        "sunrise": "04:21",
        "zuhur": "13:28",
        "asr": "18:00",
        "maghrib": "22:30",
        "isha": "23:54"
    },
    "1807": {
        "date": "1807",
        "fajr": "02:01",
        "sunrise": "04:23",
        "zuhur": "13:29",
        "asr": "18:00",
        "maghrib": "22:28",
        "isha": "23:52"
    },
    "1907": {
        "date": "1907",
        "fajr": "02:01",
        "sunrise": "04:26",
        "zuhur": "13:29",
        "asr": "17:59",
        "maghrib": "22:26",
        "isha": "23:50"
    },
    "2007": {
        "date": "2007",
        "fajr": "02:01",
        "sunrise": "04:28",
        "zuhur": "13:29",
        "asr": "17:58",
        "maghrib": "22:24",
        "isha": "23:49"
    },
    "2107": {
        "date": "2107",
        "fajr": "02:01",
        "sunrise": "04:30",
        "zuhur": "13:29",
        "asr": "17:58",
        "maghrib": "22:22",
        "isha": "23:47"
    },
    "2207": {
        "date": "2207",
        "fajr": "02:01",
        "sunrise": "04:32",
        "zuhur": "13:29",
        "asr": "17:57",
        "maghrib": "22:20",
        "isha": "23:45"
    },
    "2307": {
        "date": "2307",
        "fajr": "02:02",
        "sunrise": "04:34",
        "zuhur": "13:29",
        "asr": "17:56",
        "maghrib": "22:18",
        "isha": "23:43"
    },
    "2407": {
        "date": "2407",
        "fajr": "02:02",
        "sunrise": "04:37",
        "zuhur": "13:29",
        "asr": "17:55",
        "maghrib": "22:15",
        "isha": "23:40"
    },
    "2507": {
        "date": "2507",
        "fajr": "02:02",
        "sunrise": "04:39",
        "zuhur": "13:29",
        "asr": "17:55",
        "maghrib": "22:13",
        "isha": "23:38"
    },
    "2607": {
        "date": "2607",
        "fajr": "02:02",
        "sunrise": "04:41",
        "zuhur": "13:29",
        "asr": "17:54",
        "maghrib": "22:11",
        "isha": "23:36"
    },
    "2707": {
        "date": "2707",
        "fajr": "02:03",
        "sunrise": "04:44",
        "zuhur": "13:29",
        "asr": "17:53",
        "maghrib": "22:08",
        "isha": "23:34"
    },
    "2807": {
        "date": "2807",
        "fajr": "02:03",
        "sunrise": "04:46",
        "zuhur": "13:29",
        "asr": "17:52",
        "maghrib": "22:06",
        "isha": "23:32"
    },
    "2907": {
        "date": "2907",
        "fajr": "02:03",
        "sunrise": "04:48",
        "zuhur": "13:29",
        "asr": "17:51",
        "maghrib": "22:04",
        "isha": "23:29"
    },
    "3007": {
        "date": "3007",
        "fajr": "02:03",
        "sunrise": "04:51",
        "zuhur": "13:29",
        "asr": "17:50",
        "maghrib": "22:01",
        "isha": "23:27"
    },
    "3107": {
        "date": "3107",
        "fajr": "02:03",
        "sunrise": "04:53",
        "zuhur": "13:29",
        "asr": "17:49",
        "maghrib": "21:59",
        "isha": "23:24"
    },
    "0108": {
        "date": "0108",
        "fajr": "02:04",
        "sunrise": "04:55",
        "zuhur": "13:29",
        "asr": "17:48",
        "maghrib": "21:56",
        "isha": "23:22"
    },
    "0208": {
        "date": "0208",
        "fajr": "02:04",
        "sunrise": "04:58",
        "zuhur": "13:29",
        "asr": "17:47",
        "maghrib": "21:54",
        "isha": "23:20"
    },
    "0308": {
        "date": "0308",
        "fajr": "02:04",
        "sunrise": "05:00",
        "zuhur": "13:29",
        "asr": "17:46",
        "maghrib": "21:51",
        "isha": "23:17"
    },
    "0408": {
        "date": "0408",
        "fajr": "02:05",
        "sunrise": "05:03",
        "zuhur": "13:28",
        "asr": "17:45",
        "maghrib": "21:48",
        "isha": "23:15"
    },
    "0508": {
        "date": "0508",
        "fajr": "02:05",
        "sunrise": "05:05",
        "zuhur": "13:28",
        "asr": "17:44",
        "maghrib": "21:46",
        "isha": "23:12"
    },
    "0608": {
        "date": "0608",
        "fajr": "02:05",
        "sunrise": "05:08",
        "zuhur": "13:28",
        "asr": "17:43",
        "maghrib": "21:43",
        "isha": "23:09"
    },
    "0708": {
        "date": "0708",
        "fajr": "02:06",
        "sunrise": "05:10",
        "zuhur": "13:28",
        "asr": "17:41",
        "maghrib": "21:40",
        "isha": "23:07"
    },
    "0808": {
        "date": "0808",
        "fajr": "02:06",
        "sunrise": "05:13",
        "zuhur": "13:28",
        "asr": "17:40",
        "maghrib": "21:38",
        "isha": "23:04"
    },
    "0908": {
        "date": "0908",
        "fajr": "02:06",
        "sunrise": "05:15",
        "zuhur": "13:28",
        "asr": "17:39",
        "maghrib": "21:35",
        "isha": "23:01"
    },
    "1008": {
        "date": "1008",
        "fajr": "02:07",
        "sunrise": "05:17",
        "zuhur": "13:28",
        "asr": "17:38",
        "maghrib": "21:32",
        "isha": "22:59"
    },
    "1108": {
        "date": "1108",
        "fajr": "02:07",
        "sunrise": "05:20",
        "zuhur": "13:28",
        "asr": "17:36",
        "maghrib": "21:29",
        "isha": "22:56"
    },
    "1208": {
        "date": "1208",
        "fajr": "02:07",
        "sunrise": "05:22",
        "zuhur": "13:27",
        "asr": "17:35",
        "maghrib": "21:27",
        "isha": "22:53"
    },
    "1308": {
        "date": "1308",
        "fajr": "02:08",
        "sunrise": "05:25",
        "zuhur": "13:27",
        "asr": "17:34",
        "maghrib": "21:24",
        "isha": "22:51"
    },
    "1408": {
        "date": "1408",
        "fajr": "02:08",
        "sunrise": "05:27",
        "zuhur": "13:27",
        "asr": "17:32",
        "maghrib": "21:21",
        "isha": "22:48"
    },
    "1508": {
        "date": "1508",
        "fajr": "02:08",
        "sunrise": "05:30",
        "zuhur": "13:27",
        "asr": "17:31",
        "maghrib": "21:18",
        "isha": "22:45"
    },
    "1608": {
        "date": "1608",
        "fajr": "02:09",
        "sunrise": "05:32",
        "zuhur": "13:27",
        "asr": "17:29",
        "maghrib": "21:15",
        "isha": "22:42"
    },
    "1708": {
        "date": "1708",
        "fajr": "02:09",
        "sunrise": "05:35",
        "zuhur": "13:26",
        "asr": "17:28",
        "maghrib": "21:12",
        "isha": "22:39"
    },
    "1808": {
        "date": "1808",
        "fajr": "02:09",
        "sunrise": "05:37",
        "zuhur": "13:26",
        "asr": "17:26",
        "maghrib": "21:09",
        "isha": "22:36"
    },
    "1908": {
        "date": "1908",
        "fajr": "02:10",
        "sunrise": "05:40",
        "zuhur": "13:26",
        "asr": "17:25",
        "maghrib": "21:07",
        "isha": "22:34"
    },
    "2008": {
        "date": "2008",
        "fajr": "02:10",
        "sunrise": "05:42",
        "zuhur": "13:26",
        "asr": "17:23",
        "maghrib": "21:04",
        "isha": "22:31"
    },
    "2108": {
        "date": "2108",
        "fajr": "02:11",
        "sunrise": "05:45",
        "zuhur": "13:25",
        "asr": "17:22",
        "maghrib": "21:01",
        "isha": "00:25"
    },
    "2208": {
        "date": "2208",
        "fajr": "02:13",
        "sunrise": "05:47",
        "zuhur": "13:25",
        "asr": "17:20",
        "maghrib": "20:58",
        "isha": "00:15"
    },
    "2308": {
        "date": "2308",
        "fajr": "02:15",
        "sunrise": "05:49",
        "zuhur": "13:25",
        "asr": "17:18",
        "maghrib": "20:55",
        "isha": "00:06"
    },
    "2408": {
        "date": "2408",
        "fajr": "02:17",
        "sunrise": "05:52",
        "zuhur": "13:25",
        "asr": "17:17",
        "maghrib": "20:52",
        "isha": "23:58"
    },
    "2508": {
        "date": "2508",
        "fajr": "02:22",
        "sunrise": "05:54",
        "zuhur": "13:24",
        "asr": "17:15",
        "maghrib": "20:49",
        "isha": "23:51"
    },
    "2608": {
        "date": "2608",
        "fajr": "02:32",
        "sunrise": "05:57",
        "zuhur": "13:24",
        "asr": "17:13",
        "maghrib": "20:46",
        "isha": "23:44"
    },
    "2708": {
        "date": "2708",
        "fajr": "02:40",
        "sunrise": "05:59",
        "zuhur": "13:24",
        "asr": "17:11",
        "maghrib": "20:43",
        "isha": "23:38"
    },
    "2808": {
        "date": "2808",
        "fajr": "02:47",
        "sunrise": "06:02",
        "zuhur": "13:24",
        "asr": "17:10",
        "maghrib": "20:40",
        "isha": "23:31"
    },
    "2908": {
        "date": "2908",
        "fajr": "02:54",
        "sunrise": "06:04",
        "zuhur": "13:23",
        "asr": "17:08",
        "maghrib": "20:37",
        "isha": "23:25"
    },
    "3008": {
        "date": "3008",
        "fajr": "03:01",
        "sunrise": "06:06",
        "zuhur": "13:23",
        "asr": "17:06",
        "maghrib": "20:34",
        "isha": "23:20"
    },
    "3108": {
        "date": "3108",
        "fajr": "03:06",
        "sunrise": "06:09",
        "zuhur": "13:23",
        "asr": "17:04",
        "maghrib": "20:31",
        "isha": "23:14"
    },
    "0109": {
        "date": "0109",
        "fajr": "03:12",
        "sunrise": "06:11",
        "zuhur": "13:22",
        "asr": "17:02",
        "maghrib": "20:28",
        "isha": "23:09"
    },
    "0209": {
        "date": "0209",
        "fajr": "03:17",
        "sunrise": "06:14",
        "zuhur": "13:22",
        "asr": "17:01",
        "maghrib": "20:25",
        "isha": "23:04"
    },
    "0309": {
        "date": "0309",
        "fajr": "03:23",
        "sunrise": "06:16",
        "zuhur": "13:22",
        "asr": "16:59",
        "maghrib": "20:22",
        "isha": "22:58"
    },
    "0409": {
        "date": "0409",
        "fajr": "03:28",
        "sunrise": "06:18",
        "zuhur": "13:21",
        "asr": "16:57",
        "maghrib": "20:19",
        "isha": "22:53"
    },
    "0509": {
        "date": "0509",
        "fajr": "03:32",
        "sunrise": "06:21",
        "zuhur": "13:21",
        "asr": "16:55",
        "maghrib": "20:16",
        "isha": "22:49"
    },
    "0609": {
        "date": "0609",
        "fajr": "03:37",
        "sunrise": "06:23",
        "zuhur": "13:21",
        "asr": "16:53",
        "maghrib": "20:13",
        "isha": "22:44"
    },
    "0709": {
        "date": "0709",
        "fajr": "03:41",
        "sunrise": "06:25",
        "zuhur": "13:20",
        "asr": "16:51",
        "maghrib": "20:10",
        "isha": "22:39"
    },
    "0809": {
        "date": "0809",
        "fajr": "03:46",
        "sunrise": "06:28",
        "zuhur": "13:20",
        "asr": "16:49",
        "maghrib": "20:07",
        "isha": "22:35"
    },
    "0909": {
        "date": "0909",
        "fajr": "03:50",
        "sunrise": "06:30",
        "zuhur": "13:20",
        "asr": "16:47",
        "maghrib": "20:04",
        "isha": "22:30"
    },
    "1009": {
        "date": "1009",
        "fajr": "03:54",
        "sunrise": "06:33",
        "zuhur": "13:19",
        "asr": "16:45",
        "maghrib": "20:00",
        "isha": "22:26"
    },
    "1109": {
        "date": "1109",
        "fajr": "03:58",
        "sunrise": "06:35",
        "zuhur": "13:19",
        "asr": "16:43",
        "maghrib": "19:57",
        "isha": "22:21"
    },
    "1209": {
        "date": "1209",
        "fajr": "04:02",
        "sunrise": "06:37",
        "zuhur": "13:19",
        "asr": "16:41",
        "maghrib": "19:54",
        "isha": "22:17"
    },
    "1309": {
        "date": "1309",
        "fajr": "04:05",
        "sunrise": "06:40",
        "zuhur": "13:18",
        "asr": "16:39",
        "maghrib": "19:51",
        "isha": "22:13"
    },
    "1409": {
        "date": "1409",
        "fajr": "04:09",
        "sunrise": "06:42",
        "zuhur": "13:18",
        "asr": "16:37",
        "maghrib": "19:48",
        "isha": "22:09"
    },
    "1509": {
        "date": "1509",
        "fajr": "04:13",
        "sunrise": "06:44",
        "zuhur": "13:18",
        "asr": "16:35",
        "maghrib": "19:45",
        "isha": "22:05"
    },
    "1609": {
        "date": "1609",
        "fajr": "04:16",
        "sunrise": "06:47",
        "zuhur": "13:17",
        "asr": "16:33",
        "maghrib": "19:42",
        "isha": "22:01"
    },
    "1709": {
        "date": "1709",
        "fajr": "04:20",
        "sunrise": "06:49",
        "zuhur": "13:17",
        "asr": "16:31",
        "maghrib": "19:39",
        "isha": "21:57"
    },
    "1809": {
        "date": "1809",
        "fajr": "04:23",
        "sunrise": "06:52",
        "zuhur": "13:16",
        "asr": "16:28",
        "maghrib": "19:36",
        "isha": "21:53"
    },
    "1909": {
        "date": "1909",
        "fajr": "04:27",
        "sunrise": "06:54",
        "zuhur": "13:16",
        "asr": "16:26",
        "maghrib": "19:33",
        "isha": "21:49"
    },
    "2009": {
        "date": "2009",
        "fajr": "04:30",
        "sunrise": "06:56",
        "zuhur": "13:16",
        "asr": "16:24",
        "maghrib": "19:30",
        "isha": "21:45"
    },
    "2109": {
        "date": "2109",
        "fajr": "04:33",
        "sunrise": "06:59",
        "zuhur": "13:15",
        "asr": "16:22",
        "maghrib": "19:27",
        "isha": "21:41"
    },
    "2209": {
        "date": "2209",
        "fajr": "04:36",
        "sunrise": "07:01",
        "zuhur": "13:15",
        "asr": "16:20",
        "maghrib": "19:24",
        "isha": "21:38"
    },
    "2309": {
        "date": "2309",
        "fajr": "04:39",
        "sunrise": "07:03",
        "zuhur": "13:15",
        "asr": "16:18",
        "maghrib": "19:21",
        "isha": "21:34"
    },
    "2409": {
        "date": "2409",
        "fajr": "04:42",
        "sunrise": "07:06",
        "zuhur": "13:14",
        "asr": "16:16",
        "maghrib": "19:18",
        "isha": "21:30"
    },
    "2509": {
        "date": "2509",
        "fajr": "04:46",
        "sunrise": "07:08",
        "zuhur": "13:14",
        "asr": "16:13",
        "maghrib": "19:14",
        "isha": "21:27"
    },
    "2609": {
        "date": "2609",
        "fajr": "04:49",
        "sunrise": "07:11",
        "zuhur": "13:14",
        "asr": "16:11",
        "maghrib": "19:11",
        "isha": "21:23"
    },
    "2709": {
        "date": "2709",
        "fajr": "04:52",
        "sunrise": "07:13",
        "zuhur": "13:13",
        "asr": "16:09",
        "maghrib": "19:08",
        "isha": "21:20"
    },
    "2809": {
        "date": "2809",
        "fajr": "04:54",
        "sunrise": "07:15",
        "zuhur": "13:13",
        "asr": "16:07",
        "maghrib": "19:05",
        "isha": "21:16"
    },
    "2909": {
        "date": "2909",
        "fajr": "04:57",
        "sunrise": "07:18",
        "zuhur": "13:13",
        "asr": "16:05",
        "maghrib": "19:02",
        "isha": "21:13"
    },
    "3009": {
        "date": "3009",
        "fajr": "05:00",
        "sunrise": "07:20",
        "zuhur": "13:12",
        "asr": "16:02",
        "maghrib": "18:59",
        "isha": "21:09"
    },
    "0110": {
        "date": "0110",
        "fajr": "05:03",
        "sunrise": "07:22",
        "zuhur": "13:12",
        "asr": "16:00",
        "maghrib": "18:56",
        "isha": "21:06"
    },
    "0210": {
        "date": "0210",
        "fajr": "05:06",
        "sunrise": "07:25",
        "zuhur": "13:12",
        "asr": "15:58",
        "maghrib": "18:53",
        "isha": "21:03"
    },
    "0310": {
        "date": "0310",
        "fajr": "05:09",
        "sunrise": "07:27",
        "zuhur": "13:11",
        "asr": "15:56",
        "maghrib": "18:50",
        "isha": "20:59"
    },
    "0410": {
        "date": "0410",
        "fajr": "05:11",
        "sunrise": "07:30",
        "zuhur": "13:11",
        "asr": "15:53",
        "maghrib": "18:47",
        "isha": "20:56"
    },
    "0510": {
        "date": "0510",
        "fajr": "05:14",
        "sunrise": "07:32",
        "zuhur": "13:11",
        "asr": "15:51",
        "maghrib": "18:44",
        "isha": "20:53"
    },
    "0610": {
        "date": "0610",
        "fajr": "05:17",
        "sunrise": "07:34",
        "zuhur": "13:10",
        "asr": "15:49",
        "maghrib": "18:41",
        "isha": "20:50"
    },
    "0710": {
        "date": "0710",
        "fajr": "05:19",
        "sunrise": "07:37",
        "zuhur": "13:10",
        "asr": "15:47",
        "maghrib": "18:38",
        "isha": "20:46"
    },
    "0810": {
        "date": "0810",
        "fajr": "05:22",
        "sunrise": "07:39",
        "zuhur": "13:10",
        "asr": "15:45",
        "maghrib": "18:35",
        "isha": "20:43"
    },
    "0910": {
        "date": "0910",
        "fajr": "05:25",
        "sunrise": "07:42",
        "zuhur": "13:10",
        "asr": "15:42",
        "maghrib": "18:32",
        "isha": "20:40"
    },
    "1010": {
        "date": "1010",
        "fajr": "05:27",
        "sunrise": "07:44",
        "zuhur": "13:09",
        "asr": "15:40",
        "maghrib": "18:29",
        "isha": "20:37"
    },
    "1110": {
        "date": "1110",
        "fajr": "05:30",
        "sunrise": "07:47",
        "zuhur": "13:09",
        "asr": "15:38",
        "maghrib": "18:26",
        "isha": "20:34"
    },
    "1210": {
        "date": "1210",
        "fajr": "05:32",
        "sunrise": "07:49",
        "zuhur": "13:09",
        "asr": "15:36",
        "maghrib": "18:23",
        "isha": "20:31"
    },
    "1310": {
        "date": "1310",
        "fajr": "05:35",
        "sunrise": "07:52",
        "zuhur": "13:09",
        "asr": "15:33",
        "maghrib": "18:20",
        "isha": "20:28"
    },
    "1410": {
        "date": "1410",
        "fajr": "05:37",
        "sunrise": "07:54",
        "zuhur": "13:08",
        "asr": "15:31",
        "maghrib": "18:17",
        "isha": "20:25"
    },
    "1510": {
        "date": "1510",
        "fajr": "05:40",
        "sunrise": "07:56",
        "zuhur": "13:08",
        "asr": "15:29",
        "maghrib": "18:15",
        "isha": "20:22"
    },
    "1610": {
        "date": "1610",
        "fajr": "05:42",
        "sunrise": "07:59",
        "zuhur": "13:08",
        "asr": "15:27",
        "maghrib": "18:12",
        "isha": "20:20"
    },
    "1710": {
        "date": "1710",
        "fajr": "05:45",
        "sunrise": "08:01",
        "zuhur": "13:08",
        "asr": "15:25",
        "maghrib": "18:09",
        "isha": "20:17"
    },
    "1810": {
        "date": "1810",
        "fajr": "05:47",
        "sunrise": "08:04",
        "zuhur": "13:07",
        "asr": "15:23",
        "maghrib": "18:06",
        "isha": "20:14"
    },
    "1910": {
        "date": "1910",
        "fajr": "05:49",
        "sunrise": "08:06",
        "zuhur": "13:07",
        "asr": "15:20",
        "maghrib": "18:03",
        "isha": "20:11"
    },
    "2010": {
        "date": "2010",
        "fajr": "05:52",
        "sunrise": "08:09",
        "zuhur": "13:07",
        "asr": "15:18",
        "maghrib": "18:00",
        "isha": "20:09"
    },
    "2110": {
        "date": "2110",
        "fajr": "05:54",
        "sunrise": "08:11",
        "zuhur": "13:07",
        "asr": "15:16",
        "maghrib": "17:57",
        "isha": "20:06"
    },
    "2210": {
        "date": "2210",
        "fajr": "05:57",
        "sunrise": "08:14",
        "zuhur": "13:07",
        "asr": "15:14",
        "maghrib": "17:55",
        "isha": "20:03"
    },
    "2310": {
        "date": "2310",
        "fajr": "05:59",
        "sunrise": "08:16",
        "zuhur": "13:07",
        "asr": "15:12",
        "maghrib": "17:52",
        "isha": "20:01"
    },
    "2410": {
        "date": "2410",
        "fajr": "06:01",
        "sunrise": "08:19",
        "zuhur": "13:06",
        "asr": "15:10",
        "maghrib": "17:49",
        "isha": "19:58"
    },
    "2510": {
        "date": "2510",
        "fajr": "05:04",
        "sunrise": "07:21",
        "zuhur": "12:06",
        "asr": "14:08",
        "maghrib": "16:46",
        "isha": "18:56"
    },
    "2610": {
        "date": "2610",
        "fajr": "05:06",
        "sunrise": "07:24",
        "zuhur": "12:06",
        "asr": "14:06",
        "maghrib": "16:43",
        "isha": "18:53"
    },
    "2710": {
        "date": "2710",
        "fajr": "05:08",
        "sunrise": "07:27",
        "zuhur": "12:06",
        "asr": "14:04",
        "maghrib": "16:41",
        "isha": "18:51"
    },
    "2810": {
        "date": "2810",
        "fajr": "05:10",
        "sunrise": "07:29",
        "zuhur": "12:06",
        "asr": "14:02",
        "maghrib": "16:38",
        "isha": "18:48"
    },
    "2910": {
        "date": "2910",
        "fajr": "05:13",
        "sunrise": "07:32",
        "zuhur": "12:06",
        "asr": "14:00",
        "maghrib": "16:35",
        "isha": "18:46"
    },
    "3010": {
        "date": "3010",
        "fajr": "05:15",
        "sunrise": "07:34",
        "zuhur": "12:06",
        "asr": "13:58",
        "maghrib": "16:33",
        "isha": "18:44"
    },
    "3110": {
        "date": "3110",
        "fajr": "05:17",
        "sunrise": "07:37",
        "zuhur": "12:06",
        "asr": "13:56",
        "maghrib": "16:30",
        "isha": "18:41"
    },
    "0111": {
        "date": "0111",
        "fajr": "05:19",
        "sunrise": "07:39",
        "zuhur": "12:06",
        "asr": "13:54",
        "maghrib": "16:27",
        "isha": "18:39"
    },
    "0211": {
        "date": "0211",
        "fajr": "05:21",
        "sunrise": "07:42",
        "zuhur": "12:06",
        "asr": "13:52",
        "maghrib": "16:25",
        "isha": "18:37"
    },
    "0311": {
        "date": "0311",
        "fajr": "05:24",
        "sunrise": "07:44",
        "zuhur": "12:06",
        "asr": "13:50",
        "maghrib": "16:22",
        "isha": "18:35"
    },
    "0411": {
        "date": "0411",
        "fajr": "05:26",
        "sunrise": "07:47",
        "zuhur": "12:06",
        "asr": "13:48",
        "maghrib": "16:20",
        "isha": "18:33"
    },
    "0511": {
        "date": "0511",
        "fajr": "05:28",
        "sunrise": "07:50",
        "zuhur": "12:06",
        "asr": "13:46",
        "maghrib": "16:17",
        "isha": "18:31"
    },
    "0611": {
        "date": "0611",
        "fajr": "05:30",
        "sunrise": "07:52",
        "zuhur": "12:06",
        "asr": "13:45",
        "maghrib": "16:15",
        "isha": "18:29"
    },
    "0711": {
        "date": "0711",
        "fajr": "05:32",
        "sunrise": "07:55",
        "zuhur": "12:06",
        "asr": "13:43",
        "maghrib": "16:12",
        "isha": "18:27"
    },
    "0811": {
        "date": "0811",
        "fajr": "05:34",
        "sunrise": "07:57",
        "zuhur": "12:06",
        "asr": "13:41",
        "maghrib": "16:10",
        "isha": "18:25"
    },
    "0911": {
        "date": "0911",
        "fajr": "05:36",
        "sunrise": "08:00",
        "zuhur": "12:06",
        "asr": "13:39",
        "maghrib": "16:08",
        "isha": "18:23"
    },
    "1011": {
        "date": "1011",
        "fajr": "05:38",
        "sunrise": "08:02",
        "zuhur": "12:06",
        "asr": "13:38",
        "maghrib": "16:05",
        "isha": "18:21"
    },
    "1111": {
        "date": "1111",
        "fajr": "05:40",
        "sunrise": "08:05",
        "zuhur": "12:06",
        "asr": "13:36",
        "maghrib": "16:03",
        "isha": "18:19"
    },
    "1211": {
        "date": "1211",
        "fajr": "05:42",
        "sunrise": "08:07",
        "zuhur": "12:06",
        "asr": "13:34",
        "maghrib": "16:01",
        "isha": "18:18"
    },
    "1311": {
        "date": "1311",
        "fajr": "05:44",
        "sunrise": "08:10",
        "zuhur": "12:07",
        "asr": "13:33",
        "maghrib": "15:58",
        "isha": "18:16"
    },
    "1411": {
        "date": "1411",
        "fajr": "05:46",
        "sunrise": "08:13",
        "zuhur": "12:07",
        "asr": "13:31",
        "maghrib": "15:56",
        "isha": "18:14"
    },
    "1511": {
        "date": "1511",
        "fajr": "05:48",
        "sunrise": "08:15",
        "zuhur": "12:07",
        "asr": "13:30",
        "maghrib": "15:54",
        "isha": "18:13"
    },
    "1611": {
        "date": "1611",
        "fajr": "05:50",
        "sunrise": "08:18",
        "zuhur": "12:07",
        "asr": "13:28",
        "maghrib": "15:52",
        "isha": "18:11"
    },
    "1711": {
        "date": "1711",
        "fajr": "05:52",
        "sunrise": "08:20",
        "zuhur": "12:07",
        "asr": "13:27",
        "maghrib": "15:50",
        "isha": "18:09"
    },
    "1811": {
        "date": "1811",
        "fajr": "05:54",
        "sunrise": "08:22",
        "zuhur": "12:07",
        "asr": "13:26",
        "maghrib": "15:48",
        "isha": "18:08"
    },
    "1911": {
        "date": "1911",
        "fajr": "05:56",
        "sunrise": "08:25",
        "zuhur": "12:08",
        "asr": "13:24",
        "maghrib": "15:46",
        "isha": "18:07"
    },
    "2011": {
        "date": "2011",
        "fajr": "05:58",
        "sunrise": "08:27",
        "zuhur": "12:08",
        "asr": "13:23",
        "maghrib": "15:44",
        "isha": "18:05"
    },
    "2111": {
        "date": "2111",
        "fajr": "05:59",
        "sunrise": "08:30",
        "zuhur": "12:08",
        "asr": "13:22",
        "maghrib": "15:42",
        "isha": "18:04"
    },
    "2211": {
        "date": "2211",
        "fajr": "06:01",
        "sunrise": "08:32",
        "zuhur": "12:08",
        "asr": "13:21",
        "maghrib": "15:40",
        "isha": "18:03"
    },
    "2311": {
        "date": "2311",
        "fajr": "06:03",
        "sunrise": "08:34",
        "zuhur": "12:09",
        "asr": "13:20",
        "maghrib": "15:38",
        "isha": "18:02"
    },
    "2411": {
        "date": "2411",
        "fajr": "06:05",
        "sunrise": "08:37",
        "zuhur": "12:09",
        "asr": "13:19",
        "maghrib": "15:37",
        "isha": "18:00"
    },
    "2511": {
        "date": "2511",
        "fajr": "06:06",
        "sunrise": "08:39",
        "zuhur": "12:09",
        "asr": "13:18",
        "maghrib": "15:35",
        "isha": "17:59"
    },
    "2611": {
        "date": "2611",
        "fajr": "06:08",
        "sunrise": "08:41",
        "zuhur": "12:10",
        "asr": "13:17",
        "maghrib": "15:33",
        "isha": "17:58"
    },
    "2711": {
        "date": "2711",
        "fajr": "06:10",
        "sunrise": "08:43",
        "zuhur": "12:10",
        "asr": "13:16",
        "maghrib": "15:32",
        "isha": "17:57"
    },
    "2811": {
        "date": "2811",
        "fajr": "06:11",
        "sunrise": "08:46",
        "zuhur": "12:10",
        "asr": "13:15",
        "maghrib": "15:30",
        "isha": "17:56"
    },
    "2911": {
        "date": "2911",
        "fajr": "06:13",
        "sunrise": "08:48",
        "zuhur": "12:11",
        "asr": "13:14",
        "maghrib": "15:29",
        "isha": "17:56"
    },
    "3011": {
        "date": "3011",
        "fajr": "06:14",
        "sunrise": "08:50",
        "zuhur": "12:11",
        "asr": "13:13",
        "maghrib": "15:28",
        "isha": "17:55"
    },
    "0112": {
        "date": "0112",
        "fajr": "06:16",
        "sunrise": "08:52",
        "zuhur": "12:11",
        "asr": "13:12",
        "maghrib": "15:26",
        "isha": "17:54"
    },
    "0212": {
        "date": "0212",
        "fajr": "06:17",
        "sunrise": "08:54",
        "zuhur": "12:12",
        "asr": "13:12",
        "maghrib": "15:25",
        "isha": "17:53"
    },
    "0312": {
        "date": "0312",
        "fajr": "06:19",
        "sunrise": "08:56",
        "zuhur": "12:12",
        "asr": "13:11",
        "maghrib": "15:24",
        "isha": "17:53"
    },
    "0412": {
        "date": "0412",
        "fajr": "06:20",
        "sunrise": "08:58",
        "zuhur": "12:12",
        "asr": "13:11",
        "maghrib": "15:23",
        "isha": "17:52"
    },
    "0512": {
        "date": "0512",
        "fajr": "06:21",
        "sunrise": "08:59",
        "zuhur": "12:13",
        "asr": "13:10",
        "maghrib": "15:22",
        "isha": "17:52"
    },
    "0612": {
        "date": "0612",
        "fajr": "06:23",
        "sunrise": "09:01",
        "zuhur": "12:13",
        "asr": "13:10",
        "maghrib": "15:21",
        "isha": "17:51"
    },
    "0712": {
        "date": "0712",
        "fajr": "06:24",
        "sunrise": "09:03",
        "zuhur": "12:14",
        "asr": "13:09",
        "maghrib": "15:20",
        "isha": "17:51"
    },
    "0812": {
        "date": "0812",
        "fajr": "06:25",
        "sunrise": "09:05",
        "zuhur": "12:14",
        "asr": "13:09",
        "maghrib": "15:19",
        "isha": "17:51"
    },
    "0912": {
        "date": "0912",
        "fajr": "06:26",
        "sunrise": "09:06",
        "zuhur": "12:15",
        "asr": "13:09",
        "maghrib": "15:19",
        "isha": "17:50"
    },
    "1012": {
        "date": "1012",
        "fajr": "06:27",
        "sunrise": "09:08",
        "zuhur": "12:15",
        "asr": "13:09",
        "maghrib": "15:18",
        "isha": "17:50"
    },
    "1112": {
        "date": "1112",
        "fajr": "06:28",
        "sunrise": "09:09",
        "zuhur": "12:15",
        "asr": "13:09",
        "maghrib": "15:18",
        "isha": "17:50"
    },
    "1212": {
        "date": "1212",
        "fajr": "06:29",
        "sunrise": "09:10",
        "zuhur": "12:16",
        "asr": "13:08",
        "maghrib": "15:17",
        "isha": "17:50"
    },
    "1312": {
        "date": "1312",
        "fajr": "06:30",
        "sunrise": "09:12",
        "zuhur": "12:16",
        "asr": "13:08",
        "maghrib": "15:17",
        "isha": "17:50"
    },
    "1412": {
        "date": "1412",
        "fajr": "06:31",
        "sunrise": "09:13",
        "zuhur": "12:17",
        "asr": "13:09",
        "maghrib": "15:17",
        "isha": "17:50"
    },
    "1512": {
        "date": "1512",
        "fajr": "06:32",
        "sunrise": "09:14",
        "zuhur": "12:17",
        "asr": "13:09",
        "maghrib": "15:17",
        "isha": "17:50"
    },
    "1612": {
        "date": "1612",
        "fajr": "06:33",
        "sunrise": "09:15",
        "zuhur": "12:18",
        "asr": "13:09",
        "maghrib": "15:17",
        "isha": "17:50"
    },
    "1712": {
        "date": "1712",
        "fajr": "06:34",
        "sunrise": "09:16",
        "zuhur": "12:18",
        "asr": "13:09",
        "maghrib": "15:17",
        "isha": "17:50"
    },
    "1812": {
        "date": "1812",
        "fajr": "06:34",
        "sunrise": "09:17",
        "zuhur": "12:19",
        "asr": "13:09",
        "maghrib": "15:17",
        "isha": "17:51"
    },
    "1912": {
        "date": "1912",
        "fajr": "06:35",
        "sunrise": "09:18",
        "zuhur": "12:19",
        "asr": "13:10",
        "maghrib": "15:17",
        "isha": "17:51"
    },
    "2012": {
        "date": "2012",
        "fajr": "06:36",
        "sunrise": "09:18",
        "zuhur": "12:20",
        "asr": "13:10",
        "maghrib": "15:17",
        "isha": "17:51"
    },
    "2112": {
        "date": "2112",
        "fajr": "06:36",
        "sunrise": "09:19",
        "zuhur": "12:20",
        "asr": "13:10",
        "maghrib": "15:18",
        "isha": "17:52"
    },
    "2212": {
        "date": "2212",
        "fajr": "06:37",
        "sunrise": "09:19",
        "zuhur": "12:21",
        "asr": "13:11",
        "maghrib": "15:18",
        "isha": "17:52"
    },
    "2312": {
        "date": "2312",
        "fajr": "06:37",
        "sunrise": "09:20",
        "zuhur": "12:21",
        "asr": "13:12",
        "maghrib": "15:19",
        "isha": "17:53"
    },
    "2412": {
        "date": "2412",
        "fajr": "06:38",
        "sunrise": "09:20",
        "zuhur": "12:22",
        "asr": "13:12",
        "maghrib": "15:20",
        "isha": "17:54"
    },
    "2512": {
        "date": "2512",
        "fajr": "06:38",
        "sunrise": "09:20",
        "zuhur": "12:22",
        "asr": "13:13",
        "maghrib": "15:20",
        "isha": "17:54"
    },
    "2612": {
        "date": "2612",
        "fajr": "06:38",
        "sunrise": "09:20",
        "zuhur": "12:23",
        "asr": "13:14",
        "maghrib": "15:21",
        "isha": "17:55"
    },
    "2712": {
        "date": "2712",
        "fajr": "06:38",
        "sunrise": "09:21",
        "zuhur": "12:23",
        "asr": "13:14",
        "maghrib": "15:22",
        "isha": "17:56"
    },
    "2812": {
        "date": "2812",
        "fajr": "06:39",
        "sunrise": "09:20",
        "zuhur": "12:24",
        "asr": "13:15",
        "maghrib": "15:23",
        "isha": "17:57"
    },
    "2912": {
        "date": "2912",
        "fajr": "06:39",
        "sunrise": "09:20",
        "zuhur": "12:24",
        "asr": "13:16",
        "maghrib": "15:24",
        "isha": "17:58"
    },
    "3012": {
        "date": "3012",
        "fajr": "06:39",
        "sunrise": "09:20",
        "zuhur": "12:25",
        "asr": "13:17",
        "maghrib": "15:26",
        "isha": "17:59"
    },
    "3112": {
        "date": "3112",
        "fajr": "06:39",
        "sunrise": "09:20",
        "zuhur": "12:25",
        "asr": "13:18",
        "maghrib": "15:27",
        "isha": "18:00"
    }
};
